module.exports = __webpack_public_path__ + "img/page_header.0d198fed.png";